import React, { useState } from 'react';
import { BrandSwitcher } from '../components/BrandSwitcher';
import { VozLlamada } from '../components/VozLlamada';
import { saveLead } from '../engine/leads';
import { Perfilador } from '../components/Perfilador';
import { RAMO_DE_CATEGORIA, previasDeLead } from '../engine/perfil';
import { IconChat, IconShield, IconArrowRight, IconCheck, IconAdvisor } from '../components/icons';

const NECESIDADES = ['Estrené carro', 'Nació un hijo', 'Tembló el sábado', 'Cambié de trabajo', 'Otro momento'];
const CATEGORIAS = ['Automóvil', 'Hogar', 'Copropiedades', 'Vida', 'Accidentes personales', 'Desempleo', 'Salud', 'Educación', 'Dispositivos y movilidad', 'Asistencias de tarjeta'];
const ENTENDIDO = ['No hay letra pequeña sorpresa', 'El deducible se explica en pesos', 'Un asesor humano acompaña la decisión'];
const PREV = { productos: 'necesidad', perfil: 'productos', nombre: 'productos', whatsapp: 'nombre', consent: 'whatsapp' };

// Chat de captación embebido. Estado elevado a Sitio para conservar el avance al cerrar/reabrir.
function SitioChat({ marca, chat, setChat, onLead, onLlamar }) {
  const { paso, lead, guardado } = chat;
  const set = (patch) => setChat((c) => ({ ...c, lead: { ...c.lead, ...patch } }));
  const irA = (p) => setChat((c) => ({ ...c, paso: p }));
  const toggleProd = (cat) => setChat((c) => ({
    ...c,
    lead: { ...c.lead, productos: c.lead.productos.includes(cat) ? c.lead.productos.filter((x) => x !== cat) : [...c.lead.productos, cat] },
  }));

  const ramos = lead.productos.map((c) => RAMO_DE_CATEGORIA[c]).filter(Boolean);
  const ramoActual = ramos.find((r) => !(lead.perfil || {})[r]);
  const trasProductos = () => irA(ramos.length ? 'perfil' : 'nombre');
  const perfilListo = (r) => setChat((c) => ({ ...c, lead: { ...c.lead, perfil: { ...(c.lead.perfil || {}), [r.ramo]: r } } }));

  const finalizar = () => {
    const full = saveLead({ ...lead, marca: marca.id, entendido: ENTENDIDO });
    setChat((c) => ({ ...c, guardado: full, paso: 'listo' }));
    onLead(full);
  };

  const Cambiar = ({ to }) => (
    <button type="button" className="chatp-cambiar" onClick={() => irA(to)} data-testid="sitio-cambiar">← Cambiar</button>
  );

  return (
    <div className="chatp-body" data-testid="sitio-chat">
      <div className="chatp-bubble bot">Hola, soy el asistente virtual de <b>{marca.nombre}</b>, no una persona. En 5 minutos entiendes tus seguros, sin letra pequeña.</div>

      {paso === 'necesidad' && (
        <>
          <div className="chatp-bubble bot">¿Qué está cambiando en tu vida?</div>
          <div className="chatp-opts">
            {NECESIDADES.map((n) => (
              <button key={n} type="button" onClick={() => { set({ necesidad: n, productos: n === 'Estrené carro' && !lead.productos.length ? ['Automóvil'] : lead.productos }); irA('productos'); }} data-testid={`sitio-nec-${n}`}>{n}</button>
            ))}
          </div>
        </>
      )}

      {paso === 'productos' && (
        <>
          <div className="chatp-bubble user">{lead.necesidad}</div>
          <div className="chatp-bubble bot">¿Qué te gustaría proteger? (elige todas las que apliquen)</div>
          <div className="chatp-chips">
            {CATEGORIAS.map((c) => (
              <button key={c} type="button" className={lead.productos.includes(c) ? 'on' : ''} onClick={() => toggleProd(c)} data-testid={`sitio-cat-${c}`}>
                {lead.productos.includes(c) ? <IconCheck size={13} /> : null} {c}
              </button>
            ))}
          </div>
          <div className="chatp-row">
            <Cambiar to={PREV.productos} />
            <button type="button" className="chatp-cta" disabled={!lead.productos.length} onClick={() => { set({ perfil: {} }); trasProductos(); }} data-testid="sitio-productos-continuar">
              Continuar {lead.productos.length ? `(${lead.productos.length})` : ''} <IconArrowRight size={15} />
            </button>
          </div>
        </>
      )}

      {paso === 'perfil' && (
        <>
          <div className="chatp-bubble bot">Para comparar opciones reales, unas preguntas cortas, una a la vez. Sin ingresos ni datos de salud.</div>
          {ramos.filter((r) => (lead.perfil || {})[r] || r === ramoActual).map((r) => (
            <Perfilador key={r} ramo={r} previas={previasDeLead(lead)} locked={Boolean((lead.perfil || {})[r])} onDone={perfilListo} />
          ))}
          <div className="chatp-row">
            <Cambiar to={PREV.perfil} />
            {!ramoActual ? (
              <button type="button" className="chatp-cta" onClick={() => irA('nombre')} data-testid="sitio-perfil-continuar">
                Seguir <IconArrowRight size={15} />
              </button>
            ) : null}
          </div>
        </>
      )}

      {paso === 'nombre' && (
        <>
          <div className="chatp-bubble bot">Con {marca.nombre}: sin letra pequeña, deducible en pesos y un asesor que te acompaña. ¿Cómo te llamas?</div>
          <input className="chatp-input" placeholder="Tu nombre" value={lead.nombre} onChange={(e) => set({ nombre: e.target.value })} data-testid="sitio-nombre" />
          <div className="chatp-row">
            <Cambiar to={PREV.nombre} />
            <button type="button" className="chatp-cta" disabled={!lead.nombre.trim()} onClick={() => irA('whatsapp')} data-testid="sitio-nombre-continuar">Seguir <IconArrowRight size={15} /></button>
          </div>
        </>
      )}

      {paso === 'whatsapp' && (
        <>
          <div className="chatp-bubble bot">¿A qué WhatsApp te escribe el asesor de {marca.nombre}?</div>
          <input className="chatp-input" placeholder="Número de WhatsApp" inputMode="numeric" value={lead.whatsapp} onChange={(e) => set({ whatsapp: e.target.value.replace(/\D/g, '') })} data-testid="sitio-whatsapp" />
          <div className="chatp-row">
            <Cambiar to={PREV.whatsapp} />
            <button type="button" className="chatp-cta" disabled={lead.whatsapp.length < 7} onClick={() => irA('consent')} data-testid="sitio-whatsapp-continuar">Seguir <IconArrowRight size={15} /></button>
          </div>
        </>
      )}

      {paso === 'consent' && (
        <>
          <div className="chatp-bubble bot">Último paso: ¿autorizas que {marca.nombre} trate tus datos para contactarte sobre estos seguros?</div>
          <label className="chatp-consent" data-testid="sitio-consent-label">
            <input type="checkbox" checked={lead.consent} onChange={(e) => set({ consent: e.target.checked })} data-testid="sitio-consent" />
            Autorizo el tratamiento de mis datos personales.
          </label>
          <div className="chatp-row">
            <Cambiar to={PREV.consent} />
            <button type="button" className="chatp-cta" disabled={!lead.consent} onClick={finalizar} data-testid="sitio-finalizar">Enviar mis datos <IconArrowRight size={15} /></button>
          </div>
        </>
      )}

      {paso === 'listo' && guardado && (
        <>
          <div className="chatp-bubble bot" data-testid="sitio-lead-ok">
            ¡Listo, {guardado.nombre}! Tus datos llegaron a un asesor de {marca.nombre}. Te escribe por WhatsApp con todo lo que hablamos.
          </div>
          <button type="button" className="chatp-cta" onClick={() => onLlamar(guardado)} data-testid="sitio-llamar">
            <IconAdvisor size={15} /> Llamar ahora con un asesor
          </button>
        </>
      )}
    </div>
  );
}

const CHAT_INICIAL = { paso: 'necesidad', lead: { necesidad: null, productos: [], perfil: {}, entendido: [], nombre: '', whatsapp: '', consent: false }, guardado: null };

export default function Sitio({ marca }) {
  const [abierto, setAbierto] = useState(false);
  const [llamada, setLlamada] = useState(null);
  const [chat, setChat] = useState(CHAT_INICIAL); // se conserva aunque se cierre el popup

  const beneficios = [
    ['Sin letra pequeña', 'Te explicamos qué cubre y qué no, en palabras claras.'],
    ['Deducible en pesos', 'Lo que pondrías tú en un siniestro, en cifras, no en porcentajes sueltos.'],
    [`Un asesor de ${marca.nombre}`, 'Una persona te acompaña la decisión. El asistente nunca recomienda.'],
  ];

  return (
    <div className="sitio" style={{ '--marca': marca.color }} data-testid="sitio-page">
      <BrandSwitcher marca={marca} vista="sitio" />

      <main className="sitio-main">
        <span className="sitio-eyebrow" style={{ color: marca.color }}>Seguros con {marca.nombre}</span>
        <h1 className="sitio-titular">Entiende tus seguros en 5 minutos</h1>
        <p className="sitio-lead">Habla con nuestro asistente, sin compromiso. Un asesor de {marca.nombre} te acompaña después.</p>

        <div className="sitio-beneficios">
          {beneficios.map(([t, d]) => (
            <div className="sitio-benef" key={t} data-testid="sitio-beneficio">
              <span className="sitio-benef-ic" style={{ color: marca.color }}><IconShield size={20} /></span>
              <strong>{t}</strong>
              <span>{d}</span>
            </div>
          ))}
        </div>

        <button type="button" className="sitio-cta" style={{ background: marca.color }} onClick={() => setAbierto(true)} data-testid="sitio-abrir-chat">
          <IconChat size={18} /> Hablar con el asistente
        </button>
      </main>

      <footer className="sitio-pie" data-testid="sitio-pie">Con tecnología de MBM</footer>

      {!abierto && (
        <button type="button" className="sitio-fab" style={{ background: marca.color }} onClick={() => setAbierto(true)} data-testid="sitio-fab" aria-label="Abrir chat">
          <IconChat size={24} />
        </button>
      )}

      {abierto && (
        <div className="chatp" data-testid="sitio-chat-popup">
          <div className="chatp-head" style={{ background: marca.color }}>
            <span className="chatp-mono">{marca.mono}</span>
            <strong>Asistente de {marca.nombre}</strong>
            <button type="button" onClick={() => setAbierto(false)} data-testid="sitio-cerrar-chat" aria-label="Cerrar">×</button>
          </div>
          <SitioChat marca={marca} chat={chat} setChat={setChat} onLead={() => {}} onLlamar={(l) => setLlamada(l)} />
        </div>
      )}

      {llamada && (
        <VozLlamada marca={marca} lead={llamada} onClose={() => setLlamada(null)} />
      )}
    </div>
  );
}
